"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroup = exports.FormGroupContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const tools_1 = require("../../tools");
const Box_1 = require("../Box");
exports.FormGroupContext = react_1.createContext({ id: undefined });
const FormGroup = (_a) => {
    var { checkbox, radio, switch: switchType, id } = _a, props = __rest(_a, ["checkbox", "radio", "switch", "id"]);
    const contextValue = react_1.useMemo(() => ({ id }), [id]);
    if (checkbox) {
        return (jsx_runtime_1.jsx(exports.FormGroupContext.Provider, Object.assign({ value: contextValue }, { children: jsx_runtime_1.jsx(CheckboxBox, Object.assign({}, props), void 0) }), void 0));
    }
    if (radio) {
        return (jsx_runtime_1.jsx(exports.FormGroupContext.Provider, Object.assign({ value: contextValue }, { children: jsx_runtime_1.jsx(RadioBox, Object.assign({}, props), void 0) }), void 0));
    }
    if (switchType) {
        return (jsx_runtime_1.jsx(exports.FormGroupContext.Provider, Object.assign({ value: contextValue }, { children: jsx_runtime_1.jsx(SwitchBox, Object.assign({}, props), void 0) }), void 0));
    }
    return (jsx_runtime_1.jsx(exports.FormGroupContext.Provider, Object.assign({ value: contextValue }, { children: jsx_runtime_1.jsx(OrdinaryBox, Object.assign({}, props), void 0) }), void 0));
};
exports.FormGroup = FormGroup;
function CheckboxBox(props) {
    return jsx_runtime_1.jsx(StyledCheckboxBase, Object.assign({ padding: 0, margin: 0 }, props), void 0);
}
function RadioBox(props) {
    return jsx_runtime_1.jsx(StyledRadioBase, Object.assign({ padding: 0, margin: 0 }, props), void 0);
}
function SwitchBox(props) {
    return jsx_runtime_1.jsx(StyledSwitchBase, Object.assign({ padding: 0, margin: 0 }, props), void 0);
}
function OrdinaryBox(props) {
    return jsx_runtime_1.jsx(StyledBase, Object.assign({ display: "flex", flexDirection: "column" }, props), void 0);
}
const StyledBase = tools_1.styled(Box_1.Box) `
  &:focus-within {
    input[data-invalid='true'] {
      border-color: ${({ theme }) => theme.colors.danger};
    }
  }

  input[data-invalid='true'] ~ [data-form-feedback='true'] {
    display: block;
  }
`;
const StyledCheckboxBase = tools_1.styled(Box_1.Box) `
  input[type='checkbox'] {
    opacity: 0;
    position: absolute;
  }

  label {
    position: relative;
    padding: 0.4rem 1rem 0.25rem 1.5rem;
    user-select: none;
    cursor: pointer;
    white-space: nowrap;
  }

  /*Outer-box*/
  label::before {
    content: '';
    display: inline-block;
    height: 1rem;
    width: 1rem;
    border: 1px solid #ccc;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    background: #fff;
  }

  /*Checkmark*/
  label::after {
    content: '';
    display: inline-block;
    height: 0.4rem;
    width: 0.6rem;
    border-left: 0.2rem solid;
    border-bottom: 0.2rem solid;
    margin-left: 0.2rem;
    margin-top: 0.2rem;
    transform: rotate(-45deg);
    border-color: #222;
  }

  label::before,
  label::after {
    position: absolute;
    left: 0;
    top: 0.25rem;
  }

  /*Hide the checkmark by default*/
  input[type='checkbox'] + label::after {
    content: none;
  }
  /*Unhide the checkmark on the checked state*/
  input[type='checkbox']:checked + label::after {
    content: '';
  }

  /*Adding focus styles on the outer-box of the fake checkbox*/
  input[type='checkbox']:focus + label::before {
    outline: rgb(59, 153, 252) auto 5px;
  }
`;
const StyledRadioBase = tools_1.styled(Box_1.Box) `
  input[type='radio'] {
    opacity: 0;
    position: absolute;
  }

  label {
    position: relative;
    padding: 0.4rem 1rem 0.25rem 1.5rem;
    user-select: none;
    cursor: pointer;
    white-space: nowrap;
  }

  /*Outer-box*/
  label::before {
    content: '';
    display: inline-block;
    height: 1rem;
    width: 1rem;
    border: 1px solid #ccc;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 50%;
  }

  /*Checkmark*/
  label::after {
    content: '';
    display: inline-block;
    height: 0.75rem;
    width: 0.75rem;
    border-radius: 50%;
    margin-left: 0.2rem;
    margin-top: 0.2rem;
    background-color: #222;
  }

  label::before,
  label::after {
    position: absolute;
    left: 0;
    top: 0.25rem;
  }

  /*Hide the checkmark by default*/
  input[type='radio'] + label::after {
    content: none;
  }
  /*Unhide the checkmark on the checked state*/
  input[type='radio']:checked + label::after {
    content: '';
  }

  /*Adding focus styles on the outer-box of the fake radio*/
  input[type='radio']:focus + label::before {
    outline: rgb(59, 153, 252) auto 5px;
  }
`;
const StyledSwitchBase = tools_1.styled(Box_1.Box) `
  input[type='checkbox'] {
    opacity: 0;
    position: absolute;
  }

  label {
    position: relative;
    padding-left: 3rem;
    user-select: none;
    cursor: pointer;
  }

  /*Outer-box*/
  label::before {
    content: '';
    display: inline-block;
    height: 1.5rem;
    width: 2.5rem;
    background: #ccc;
    border-radius: 0.75rem;
  }

  /*Checkmark*/
  label::after {
    content: '';
    display: inline-block;
    width: 1.1rem;
    height: 1.1rem;
    margin: 0 0.2rem;
    border-radius: 0.55rem;
    background: #fff;
  }

  label::before,
  label::after {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.3s;
  }

  // Move the ball to the right when "checked"
  input[type='checkbox']:checked + label::after {
    left: 1rem;
  }
  input[type='checkbox']:checked + label::before {
    background: ${({ theme }) => { var _a, _b; return (_b = (_a = theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.accent; }};
  }

  /*Adding focus styles on the outer-box of the fake checkbox*/
  input[type='checkbox']:focus + label::before {
    outline: rgb(59, 153, 252) auto 5px;
  }
`;
//# sourceMappingURL=index.js.map